import BilletRequests from "app/api/billet";
import { handleGenericApiError } from "app/api/error";

import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_BILLETS = "contract:ACTION_SAVE_BILLETS";
export const ACTION_SAVE_BILLET_GENERAL_INFORMATION =
  "contract:ACTION_SAVE_BILLET_GENERAL_INFORMATION";
export const ACTION_SAVE_BILLET_GENERATION_HISTORY =
  "contract:ACTION_SAVE_BILLET_GENERATION_HISTORY";

export const fetchBillets = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await BilletRequests.fetchBillets(params);

    dispatch({ type: ACTION_SAVE_BILLETS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchBilletGeneralInformation = callback => async dispatch => {
  try {
    const data = await BilletRequests.fetchBilletGeneralInformation();
    if (callback && typeof callback === "function") {
      callback();
    }
    dispatch({ type: ACTION_SAVE_BILLET_GENERAL_INFORMATION, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const fetchBilletGenerationHistory = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await BilletRequests.fetchBilletGenerationHistory(params);
    dispatch({ type: ACTION_SAVE_BILLET_GENERATION_HISTORY, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const processPendingBillets = (data, callback) => async dispatch => {
  try {
    await BilletRequests.processPendingBillets(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const deletePriorApproval = (data, callback) => async dispatch => {
  try {
    await BilletRequests.deletePriorApproval(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const importCsvBillet = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    let response = await BilletRequests.importCsvBillet(data);
    if (callback && typeof callback === "function") {
      callback();
    }
    return response;
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const createBilletFromInstallment =
  (data, callback) => async dispatch => {
    dispatch(addLoading());
    try {
      let response = await BilletRequests.createBilletFromInstallment(data);
      if (callback && typeof callback === "function") {
        callback();
      }
      return response;
    } catch (err) {
      handleGenericApiError(err);
      throw err;
    } finally {
      dispatch(removeLoading());
    }
  };

export const getContractInstallmentStatusJob =
  (data, callback) => async dispatch => {
    dispatch(addLoading());
    try {
      const data = await BilletRequests.getContractInstallmentStatusJob();
      return data;
    } catch (err) {
      handleGenericApiError(err);
      throw err;
    } finally {
      dispatch(removeLoading());
    }
  };
